// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ColumnsIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ColumnsIcon" ref={forwardedRef} {...props}>
      <path d="M4 3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm.5 1.5h2.626v11H4.5zm6.876 11h-2.75v-11h2.75zm1.5 0v-11H15.5v11z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ColumnsIcon = /* @__PURE__ */ Object.assign(ColumnsIconComponent, {
  displayName: 'ColumnsIcon',
});
